import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="border-t border-border mt-24 bg-secondary/30">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-4">
      <div className="md:col-span-2">
        <p className="serif text-3xl font-semibold">The Chair <span className="text-accent">Index</span></p>
        <p className="text-sm text-muted-foreground mt-3 max-w-sm">
          A visual catalog and history of chair design. Built from openly-licensed collections —
          every image links back to its owning institution.
        </p>
      </div>
      <div>
        <p className="overline mb-4">Explore</p>
        <ul className="space-y-2 text-sm">
          <li><Link to="/catalog" className="hover:text-accent">Catalog</Link></li>
          <li><Link to="/timeline" className="hover:text-accent">Timeline</Link></li>
          <li><Link to="/designers" className="hover:text-accent">Designers</Link></li>
          <li><Link to="/movements" className="hover:text-accent">Movements</Link></li>
          <li><Link to="/identify" className="hover:text-accent">Identify a Chair</Link></li>
        </ul>
      </div>
      <div>
        <p className="overline mb-4">About</p>
        <p className="text-sm text-muted-foreground">
          Content sourced from Wikimedia Commons, The Met Open Access, Rijksmuseum and MoMA
          where licensing permits. Some famous chairs are shown via representative photography.
        </p>
        <Link to="/admin" className="text-xs text-muted-foreground/70 hover:text-accent mt-4 inline-block" data-testid="footer-admin-link">
          Curator login
        </Link>
      </div>
    </div>
    <div className="border-t border-border py-5 text-center text-xs text-muted-foreground">
      © {new Date().getFullYear()} The Chair Index — an ad-supported, open catalog. Attribution always one click away.
    </div>
  </footer>
);
